if (!customElements.get('wls-buybox')) {
    class WLSBuybox extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                gallery: 'js-wls-buybox-gallery',
                thumbs: 'js-wls-buybox-gallery-thumb',
                list: 'splide__list',
                item: 'splide__slide',
            };
            this.elements = {
                gallery: this.querySelector(`.${this.classes.gallery}`),
                thumbs: this.querySelector(`.${this.classes.thumbs}`),
                list: this.querySelector(`.${this.classes.list}`),
                items: this.querySelectorAll(`.${this.classes.item}`),
            }

            this.resizeHandler = this.handleResize.bind(this);
        }

        connectedCallback() {
            if (this.checkIfEmpty()) return;
            this.init();
            window.addEventListener('resize', this.resizeHandler);
        }

        disconnectedCallback() {
            if (this.splide) {
                this.splide.destroy(true);
                this.splide = null;
            }

            window.removeEventListener('resize', this.resizeHandler);

            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
        }

        checkIfEmpty() {
            const listInner = this.elements.list;

            if (!listInner || !listInner.children.length) {
                this.style.display = 'none';
                return true;
            }

            return false;
        }

        init() {
            if (!this.shouldInitialize()) return;
            this.initializeSplide();
        }

        shouldInitialize() {
            if (!this.elements.gallery || !this.elements.items.length) return false;

            const slidesCount = this.elements.items.length;

            if (slidesCount <= 1 ) {
                return false;
            }
            return true;
        }

        handleResize() {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            this.resizeTimeout = setTimeout(() => {
                const shouldInit = this.shouldInitialize();

                if (shouldInit && !this.splide) {
                    this.initializeSplide();
                } else if (!shouldInit && this.splide) {
                    this.splide.destroy(true);
                    this.splide = null;
                } else if (this.splide) {
                    this.createPagination();
                }
            }, 300);
        }

        initializeSplide() {
            const main = new Splide(this.elements.gallery, {
                type      : 'fade',
                pagination: false,
                arrows    : false,
                cover     : true,
            });
            
            const thumbs = new Splide(this.elements.thumbs, {
                rewind      : true,
                isNavigation: true,
                gap         : 16,
                focus       : 'center',
                pagination  : false,
                cover       : true,
                arrows      : false,
                perPage: 5,
              });
          
              main.sync(thumbs);
              main.mount();
              thumbs.mount();
        }
    }

    customElements.define('wls-buybox', WLSBuybox);
}

if (!customElements.get('wls-buybox-sticky-cta')) {
    class WLSBuyboxStickyCta extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                active: 'is-active',
                bodyActive: 'has-wls-buybox-sticky-cta',
            };
            this.updateVisibility = this.updateVisibility.bind(this);
            this.handleAtcClick = this.handleAtcClick.bind(this);
        }

        connectedCallback() {
            const buyboxSelector = this.getAttribute('data-buybox-selector');
            this.buybox = buyboxSelector ? document.querySelector(buyboxSelector) : document.querySelector('.js-wls-buybox-original');
            this.trigger = this.buybox ? (this.buybox.querySelector('.wls-buybox__buttons') || this.buybox) : null;
            this.footer = document.querySelector('#wls-footer')
                || document.querySelector('wls-footer')
                || document.querySelector('.wls-footer');
            this.callBtn = this.querySelector('[data-sticky-call]');
            this.atcBtn = this.querySelector('[data-sticky-atc]');
            this.onScroll = this.onScroll.bind(this);

            this.hydrateCallButton();
            this.bindAtc();

            if (!this.callBtn && !this.atcBtn) {
                const actions = this.querySelector('.wls-buybox-sticky-cta__actions');
                if (actions) actions.remove();
            }

            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.updateVisibility, { passive: true });
            this.updateVisibility();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.updateVisibility);
            if (this.scrollTick) {
                cancelAnimationFrame(this.scrollTick);
                this.scrollTick = null;
            }
            if (this.atcBtn) {
                this.atcBtn.removeEventListener('click', this.handleAtcClick);
            }
            this.hide();
        }

        hydrateCallButton() {
            if (!this.callBtn) return;

            let phone = (this.callBtn.dataset.phone || '').trim();

            if (!phone) {
                const header = document.querySelector('wls-header[data-store-phone]');
                phone = header ? (header.getAttribute('data-store-phone') || '').trim() : '';
            }

            if (!phone) {
                this.callBtn.remove();
                this.callBtn = null;
                return;
            }

            const tel = phone.replace(/[^\d+]/g, '');
            this.callBtn.href = `tel:${tel}`;
            this.callBtn.hidden = false;

            const desktopLabel = this.callBtn.querySelector('[data-call-label-d]');
            if (desktopLabel && !desktopLabel.textContent.trim()) {
                desktopLabel.textContent = phone;
            }
        }

        bindAtc() {
            if (!this.atcBtn) return;
            this.atcBtn.addEventListener('click', this.handleAtcClick);
        }

        handleAtcClick(event) {
            event.preventDefault();

            const mainForm = document.querySelector('product-form.main-product-form[data-main="true"]');
            const mainBtn = mainForm && mainForm.querySelector('button[type="submit"][name="add"]');

            if (mainBtn) {
                mainBtn.click();
                return;
            }

            if (mainForm && typeof mainForm.handleSubmit === 'function') {
                mainForm.handleSubmit(event);
            }
        }

        isBuyboxAvailable() {
            if (!this.buybox) return false;
            const style = window.getComputedStyle(this.buybox);
            return style.display !== 'none' && style.visibility !== 'hidden';
        }

        onScroll() {
            if (this.scrollTick) return;
            this.scrollTick = requestAnimationFrame(() => {
                this.scrollTick = null;
                this.updateVisibility();
            });
        }

        isFooterReached() {
            if (!this.footer) return false;
            return this.footer.getBoundingClientRect().top <= window.innerHeight;
        }

        updateVisibility() {
            if (!this.trigger || !this.isBuyboxAvailable()) {
                this.hide();
                return;
            }

            const scrolledPastBuybox = this.trigger.getBoundingClientRect().bottom <= 0;

            if (scrolledPastBuybox && !this.isFooterReached()) {
                this.show();
                return;
            }

            this.hide();
        }

        show() {
            this.classList.add(this.classes.active);
            this.setAttribute('aria-hidden', 'false');
            document.body.classList.add(this.classes.bodyActive);
            document.documentElement.style.setProperty('--wls-buybox-sticky-cta-height', `${this.offsetHeight}px`);
        }

        hide() {
            this.classList.remove(this.classes.active);
            this.setAttribute('aria-hidden', 'true');
            document.body.classList.remove(this.classes.bodyActive);
            document.documentElement.style.removeProperty('--wls-buybox-sticky-cta-height');
        }
    }

    customElements.define('wls-buybox-sticky-cta', WLSBuyboxStickyCta);
}
